var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0008 0.00044 72 0.00044 72 8.13844 0.0008 8.13844"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0008 0.00052 72 0.00052 72 8.13852 0.0008 8.13852"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_visa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 0,
    y: 0,
    width: 72,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2385895,15.313901 L31.5632766,32.4966395 L27.1179046,32.4966395 L30.7935514,15.313901 L35.2385895,15.313901 Z M53.9404084,26.4092983 L56.2806402,19.9562959 L57.6267411,26.4092983 L53.9404084,26.4092983 Z M58.9027151,32.4966395 L63.0128142,32.4966395 L59.4216535,15.313901 L55.6301306,15.313901 C54.7752513,15.313901 54.0552827,15.8094638 53.7363727,16.5735121 L47.0659772,32.4966395 L51.7347532,32.4966395 L52.6614289,29.9306661 L58.3637405,29.9306661 L58.9027151,32.4966395 Z M47.2977296,26.8871625 C47.3170979,22.3526292 41.0290605,22.1011745 41.0708026,20.0748436 C41.0844941,19.4590634 41.6715557,18.8035447 42.9558781,18.6359082 C43.5923624,18.5537597 45.3488721,18.4873062 47.3401396,19.4046317 L48.1188812,15.7593732 C47.0489464,15.3726739 45.6727912,15 43.9606952,15 C39.5660816,15 36.474491,17.334221 36.4497797,20.6796039 C36.421729,23.1534107 38.6584403,24.5329052 40.3398141,25.3567283 C42.0732821,26.198584 42.6543328,26.7388944 42.6459844,27.4912549 C42.6339627,28.6440061 41.2631505,29.1545961 39.9875104,29.1736305 C37.7511329,29.2086939 36.4551227,28.5695381 35.421921,28.0876667 L34.6151287,31.8548122 C35.6553431,32.3306728 37.5724765,32.7454228 39.5570653,32.7664608 C44.2288467,32.7664608 47.2840382,30.4596226 47.2977296,26.8871625 Z M28.88677,15.313901 L21.6840785,32.4966395 L16.9855822,32.4966395 L13.4408388,18.7835085 C13.2261172,17.940651 13.0387784,17.6304233 12.3852633,17.2744463 C11.3163303,16.6933955 9.55147223,16.1504137 8,15.8128031 L8.10485628,15.313901 L15.6692017,15.313901 C16.6329445,15.313901 17.4995115,15.9550604 17.7199101,17.0650676 L19.5922959,27.0087156 L24.2166583,15.313901 L28.88677,15.313901 Z",
    id: "Fill-5",
    fill: "#253338"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0008,4.00044 C72.0008,2.91644 71.6048,1.97844 70.8108,1.18844 C70.0208,0.39644 69.0828,0.00044 68.0008,0.00044 L4.0008,0.00044 C2.9168,0.00044 1.9788,0.39644 1.1888,1.18844 C0.3948,1.97844 0.0008,2.91644 0.0008,4.00044 L0.0008,8.13844 L72.0008,8.13844 L72.0008,4.00044 Z",
    id: "Fill-1",
    fill: "#253338",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0008,4.13852 C0.0008,5.22252 0.3948,6.15852 1.1888,6.95252 C1.9788,7.74252 2.9168,8.13852 4.0008,8.13852 L68.0008,8.13852 C69.0828,8.13852 70.0208,7.74252 70.8108,6.95252 C71.6048,6.15852 72.0008,5.22252 72.0008,4.13852 L72.0008,0.00052 L0.0008,0.00052 L0.0008,4.13852 Z",
    id: "Fill-1",
    fill: "#FCA468",
    mask: "url(#mask-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "assets/media/visa.469e9acff45e2a627e0a9f7dee8afdb3.svg";
export { ForwardRef as ReactComponent };